export default class DimensionModel {
    constructor(data = {}) {
        this.id = data.id;
        this.name = data.name;
        this.incarnation = data.incarnation
    }
}

